import { render, staticRenderFns } from "./DocumentsCommerciauxEspace.vue?vue&type=template&id=b2e3ad56&scoped=true&"
import script from "./DocumentsCommerciauxEspace.vue?vue&type=script&lang=js&"
export * from "./DocumentsCommerciauxEspace.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCommerciauxEspace.vue?vue&type=style&index=0&id=b2e3ad56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e3ad56",
  null
  
)

export default component.exports